import { buildCommissionDetailsCard } from '../../shared';

export const commissionDetailsCard = buildCommissionDetailsCard({
  label: 'Tenant Agent’s Compensation',
  additionalLabel: 'Additional Tenant Agent’s Compensation',
  typeLabel: 'Tenant Agent’s Compensation Type',
});
